import {
  BlessingResponse,
  getGiftCardGetAllBlessingSlug,
  getGiftCardGetBlessingSlug,
  getGiftCardGetGiftCardSetting,
  GiftCardSettingModel,
} from "api"
import SeoMetaData, { SeoMetadataWithImage } from "common/SeoMetaData"
import KeyboardNavigation from "components/KeyboardNavigation/KeyboardNavigation"
import PurchaseProcess from "components/PurchasePage/PurchaseProcess"
import { GetStaticPaths, GetStaticProps } from "next"
import { useState } from "react"

type BlessingSlugProps = {
  giftcardName: string
}

type BlessingGiftCardProps = {
  giftCard: BlessingResponse
  setting: GiftCardSettingModel
  seo: SeoMetadataWithImage
}

export const getStaticPaths: GetStaticPaths<BlessingSlugProps> = async () => {
  const { data } = await getGiftCardGetAllBlessingSlug()
  const paths = data.body.map((slug) => ({
    params: {
      giftcardName: slug.toString(),
    },
  }))

  return {
    paths,
    fallback: "blocking",
  }
}

export const getStaticProps: GetStaticProps<BlessingGiftCardProps> = async ({
  params,
}) => {
  const [giftCard, setting] = await Promise.all([
    await getGiftCardGetBlessingSlug(
      encodeURIComponent(params.giftcardName.toString())
    ),
    await getGiftCardGetGiftCardSetting(),
  ])

  const seo = {
    title: giftCard?.data?.body?.pageTitle || "",
    description: giftCard?.data?.body?.metaDescription || "",
    keywords: giftCard?.data?.body?.keywords || "",
  }

  return {
    props: {
      giftCard: giftCard?.data?.body,
      setting: setting?.data?.body,
      seo: seo,
    },
    revalidate: 60,
  }
}

const GiftcardName = ({ giftCard, setting, seo }: BlessingGiftCardProps) => {
  const [refList, setRefList] = useState([])

  return (
    <>
      <KeyboardNavigation refList={refList} />
      <SeoMetaData data={seo} />
      <PurchaseProcess
        giftCard={giftCard}
        setting={setting}
        setRefList={setRefList}
      />
    </>
  )
}

export default GiftcardName
